import { Link } from "react-router-dom";
import { MapPin, Mail, FileBadge } from "lucide-react";
import { Logo } from "./Logo";
import { useLanguage } from "@/context/LanguageContext";

const menuRoutes = [
    { to: "/", key: "home" },
    { to: "/gioi-thieu", key: "about" },
    { to: "/dich-vu", key: "services" },
    { to: "/du-an", key: "projects" },
    { to: "/blog", key: "blog" },
    { to: "/lien-he", key: "contact" },
];

export default function Footer() {
    const { t } = useLanguage();

    return (
        <footer className="relative border-t border-slate-800/70 bg-ink2/40" data-testid="footer">
            <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
                <div className="grid gap-12 lg:grid-cols-12">
                    <div className="lg:col-span-5">
                        <Logo />
                        <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
                            {t.footer.tagline}
                        </p>
                        <div className="mt-8 space-y-3 text-sm text-slate-400">
                            <p className="flex items-start gap-3">
                                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-neon" />
                                <span data-testid="footer-address">
                                    236/13A Điện Biên Phủ, Phường Gia Định, TP. Hồ Chí Minh
                                </span>
                            </p>
                            <p className="flex items-center gap-3">
                                <Mail className="h-4 w-4 shrink-0 text-neon" />
                                <a
                                    href="mailto:admin@maxthsolutions.org"
                                    data-testid="footer-email"
                                    className="transition-colors hover:text-neon"
                                >
                                    admin@maxthsolutions.org
                                </a>
                            </p>
                            <p className="flex items-center gap-3">
                                <FileBadge className="h-4 w-4 shrink-0 text-neon" />
                                <span data-testid="footer-tax">{t.footer.tax}</span>
                            </p>
                        </div>
                    </div>

                    <div className="lg:col-span-3">
                        <h3 className="font-mono text-xs font-medium uppercase tracking-[0.24em] text-slate-500">
                            {t.footer.colMenu}
                        </h3>
                        <ul className="mt-6 space-y-3">
                            {menuRoutes.map((r) => (
                                <li key={r.key}>
                                    <Link
                                        to={r.to}
                                        data-testid={`footer-link-${r.key}`}
                                        className="text-sm text-slate-400 transition-colors hover:text-neon"
                                    >
                                        {t.nav[r.key]}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-4">
                        <h3 className="font-mono text-xs font-medium uppercase tracking-[0.24em] text-slate-500">
                            {t.footer.colServices}
                        </h3>
                        <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
                            {t.services.items.map((s) => (
                                <li key={s.id}>
                                    <Link
                                        to="/dich-vu"
                                        data-testid={`footer-service-${s.id}`}
                                        className="text-sm text-slate-400 transition-colors hover:text-neon"
                                    >
                                        {s.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="mt-16 flex flex-col gap-4 border-t border-slate-800/70 pt-8 sm:flex-row sm:items-center sm:justify-between">
                    <p className="text-xs text-slate-500">
                        © 2026 MAXTH Solutions. {t.footer.rights}
                    </p>
                    <a
                        href="https://maxthsolutions.org"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-tempmail-link"
                        className="font-mono text-xs text-slate-500 transition-colors hover:text-neon"
                    >
                        maxthsolutions.org
                    </a>
                </div>
            </div>
            <div
                aria-hidden="true"
                className="pointer-events-none select-none overflow-hidden pb-2 text-center font-display text-[18vw] font-extrabold leading-none tracking-tight text-outline opacity-40 lg:text-[13rem]"
            >
                MAXTH
            </div>
        </footer>
    );
}
